import styled from 'styled-components';

export const ContainerBotao = styled.button`
  background: none;
  outline: none;
  width: 100%;
`;

export const ContainerIcone = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ theme }) => theme.tamanhoCartaz.height['extraPequeno']}px;
  width: ${({ theme }) => theme.tamanhoCartaz.width['extraPequeno']}px;
  border-radius: ${({ theme }) => theme.radius[2]}px;
  background-color: ${({ theme }) => theme.colors.accent.accent[7]};
  margin-right: ${({ theme }) => theme.spacing[4]}px;
`;

export const Row = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  flex: 1;
  width: 100%;
`;
